module.exports = __webpack_public_path__ + "img/case6-jpg.dc0cc5a7.jpg";